// libs
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import PortalVue from 'portal-vue';
import VueYoutube from 'vue-youtube';

// plugins
import router from './router';
import store from './store/store';
import './plugins/vuetify';
import './plugins/vue-leaflet';

// app
import App from './App.vue';
import './styles/main.scss';

import vuetify from './plugins/vuetify'; // path to vuetify export
import helpers from './helpers';

Vue.use(PortalVue);
Vue.use(VueYoutube);

Vue.config.productionTip = false;

Vue.prototype.$helpers = helpers;
Vue.prototype.$publicPath = process.env.BASE_URL;

const unsync = sync(store, router); // done. Returns an unsync callback fn

// Vue.mixin({
//   mounted() {
//     const blacklist = ['v-', '-L', 'transition', 'theme-provider', 'context-menu', 'RouterLink',];
//     if (this.$vnode && !blacklist.some(string => this.$vnode.tag.includes(string))) {
//       console.log(`mounted:\t${this.$vnode.tag.split('-').pop()}`);
//     }
//   },
// });

// router.beforeResolve((to, from, next) => {
//   console.log(to);
//   next();
// });


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  destroyed() {
    console.warn('APP DESTROYED!!!!');
    unsync();
  },
}).$mount('#app');
